import BaseModel from "./base/baseModel";

export default class EspecialidadeModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
}
